import type { ReactNode } from "react";
import { Skeleton } from "../Skeleton";

/**
 * Cifra en línea (conteo del encabezado, total de un resumen) · mientras no hay
 * dato pinta una barra del mismo alto de texto en vez de un «0» falso.
 */
export function CifraCargando({ valor, ancho = 24 }: { valor: ReactNode | null | undefined; ancho?: number }) {
  if (valor !== null && valor !== undefined) return <>{valor}</>;
  return <Skeleton height="0.9em" width={ancho} className="inline-block align-middle" aria-label="Cargando" />;
}
